import React from 'react';

import { Box, Grid } from '@mui/material';
import { useL10n } from '@uplift/hooks';

import { TextInput } from '../../../../../Inputs';

export type UserInfoBoxProps = {
  name: string;
};

const UserInfoBox: React.FC<UserInfoBoxProps> = ({ ...props }) => {
  return <Box {...props} />;
};

export const UserInfoInvite: React.VFC = () => {
  const l10n = useL10n();


  return (
    <UserInfoBox name="invitedPatient">
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}>
          <TextInput name="invitedPatient.firstName" label={l10n.schedule.createAppointment.firstName} fullWidth />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6
          }}>
          <TextInput name="invitedPatient.lastName" label={l10n.schedule.createAppointment.lastName} fullWidth />
        </Grid>
        <Grid size={12}>
          <TextInput name="invitedPatient.email" type="email" label={l10n.schedule.createAppointment.email} fullWidth />
        </Grid>
      </Grid>
    </UserInfoBox>
  );
};
